import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function PeopleIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 6C6.3 6 5 4.7 5 3C5 1.3 6.3 0 8 0C9.7 0 11 1.3 11 3C11 4.7 9.7 6 8 6Z" />
        <path d="M10 16H6V12L4 10V7H12V10L10 12V16Z" />
        <path d="M2 5C0.9 5 0 4.1 0 3C0 1.9 0.9 1 2 1C3.1 1 4 1.9 4 3C4 4.1 3.1 5 2 5Z" />
        <path d="M3 10.4V6H0V9L1 10V14H4V11.4L3 10.4Z" />
        <path d="M14 5C15.1 5 16 4.1 16 3C16 1.9 15.1 1 14 1C12.9 1 12 1.9 12 3C12 4.1 12.9 5 14 5Z" />
        <path d="M13 10.4V6H16V9L15 10V14H12V11.4L13 10.4Z" />
      </svg>
    </Icon>
  );
}
